import { propOr, identity } from 'ramda';

/**
 * @method createReducer
 * @description Generates a reducer function from an initial state object and handler object
 * @param  {Object} initialState - The initial state passed to the reducer, defaults to empty object
 * @param  {Object} handlers - Object containing handlers that map to action types
 * @return {Function} A redux reducer function
 */
const createReducer =
  (initialState = {}, handlers) =>
  (state = initialState, action) =>
    propOr(identity, action.type, handlers)(state, action);

export default createReducer;
